import Card from "@mui/material/Card";
import * as React from "react";

import { Form } from "../Form";

import { ALIGN, COLOR, FormActions, VARIANT } from "./FormActions";
import { FormBody } from "./FormBody/FormBody";
import { FormTitle } from "./FormTitle";

import { Alert } from "@mui/material";
import { useEffect } from "react";
import App from "src/pi/application/App";
import { Action } from "src/pi/context/IForm";
import "./Form.css";
import { Loading } from "./Loading";

export interface ActionProps {
    variant?: VARIANT;
    color?: COLOR;
    align?: ALIGN;
    onActionAsync?: (action: Action, form: Form) => Promise<any>;
}

interface Props {
    form: Form | string;
    autoFocus?: boolean;
    actionProps?: ActionProps;
    style?: React.CSSProperties;
    title?: string;
}

interface State {
    form?: Form;
}

export class VerticalForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const form = typeof this.props.form === "string" ? undefined : this.props.form;

        this.state = {
            form: form,
        };
    }

    async componentDidMount() {
        if (typeof this.props.form === "string") {
            const form = await App().loadFormAsync(this.props.form);
            this.setState({ form });
        }
    }

    render() {
        const { style, title } = this.props;
        const { form } = this.state;

        if (!form) {
            return <Card className="pi-form"></Card>;
        }

        return (
            <Card className="pi-form" style={style}>
                <FormTitle form={form} title={title} />
                <FormBody {...this.props} form={form} />
                <FormActions {...this.props.actionProps} form={form} />
            </Card>
        );
    }
}


interface IEmbeddedFormProps {
    formPath: string;
    style?: React.CSSProperties;
    title?: string;
}

export function EmbeddedForm(props: IEmbeddedFormProps) {
    const { style, formPath, title } = props;
    const [isLoading, setLoading] = React.useState(false);
    const [form, setForm] = React.useState<Form>();
    const [error, setError] = React.useState<string>();

    const loadForm = React.useCallback(()=>{
        setLoading(true);
        App().loadFormAsync(formPath)
            .then(f => {
                if (!f) {
                    setError("Failed to load form");
                    return;
                }

                setForm(f);
            });
    }, [formPath]);

    useEffect(() => {        
        if (form){
            console.log('form loaded');
            setLoading(false);
            setError(undefined);
            return;
        }
        loadForm();

    }, [loadForm, form]);

    const onActionAsync = async (action: Action, form: Form) => {
        const result = await form!.executeAsync(action);
        if (typeof (result) === "object" && "success" in result && result["success"]) {
            // const nextUrl = result["nextUrl"];
            // if (nextUrl === "#reload") {
                // setForm(undefined);
            // }

            // always reload on success
            setForm(undefined);
        }
    };

    if (error) {
        return (
            <div style={style}>
                <Alert severity="error">{error}</Alert>
            </div>
        );
    }

    if (isLoading || !form) {
        return (
            <div style={style}>
                <Loading />
            </div>
        );
    }

    return (
        <div style={style}>
            <FormTitle form={form} title={title} />
            <FormBody form={form} />
            <FormActions form={form} onActionAsync={onActionAsync} />
        </div>
    );
}
